import { IRequest } from "../../utilities/HttpRequest";

export const practicesEndpoints = {
  getDSAList: (): IRequest => {
    return {
      relativeUrl: "/v1/practices?search=dsa",
      endPoint: process.env.APP_FEASIBILITY_SERVICE_API,
    };
  },
  getPracticeListFromDSA: (dsa: string): IRequest => {
    return {
      relativeUrl: `/v1/practices?search=dsa-practices&dsa=${dsa}`,
      endPoint: process.env.APP_FEASIBILITY_SERVICE_API,
    };
  },
  getPracticeListFromCDB: (cdb: string): IRequest => {
    return {
      relativeUrl: `/v1/practices?search=cdb-practices&cdb=${cdb}`,
      endPoint: process.env.APP_FEASIBILITY_SERVICE_API,
    };
  }
};
